<mm-banners *ngIf="(abaChangedMessage !== '')" [bannerText]="[abaChangedMessage]" [type]="'information'" data-testid="aba-changed-alert"></mm-banners>
<div [formGroup]="parentForm" class="row" id="wire-aba-container" *ngIf="!useSloa">
  <div class="column-1">
    <div class="input-container">
      <label id="bank-id-label" for="aba" [class.error-text]="aba.touched && aba.invalid" data-testid="aba-label">{{abaLabel}}</label>
      <input [readonly] = "useSloa" (blur)="displayValidation(parentForm.controls.aba); retryDetailsCall()"
        (keydown)="validationService.validateNumberInput($event, abaAllowedChars); aba.markAsDirty();"
        (keydown.enter)="blurInputField($event); retryDetailsCall()" class="sdps-input sdps-input--small"
        [class.error-input]="aba.touched && aba.invalid" id="aba" data-testid="aba-input" name="aba" type="text" formControlName="aba" maxlength="9">
      <i *ngIf="(aba?.dirty || aba?.value) && !isAbaReadonly" (click)="clearAba()" class="sch-thin-x" data-testid="clear-x"></i>
      <div *ngIf="aba?.touched && aba.invalid" class="alert-text" data-testid="abaValidationError">
        {{abaValidationError}}
      </div>
    </div>
  </div>
  <div class="column-2">
    <div *ngIf="(wireInfo$ | async)?.loading" class="spinner-container">
      <mm-spinner [loading]="wireInfo$"></mm-spinner>
    </div>
    <div *ngIf="((wireInfo$ | async)?.detailsCallSucceeded && (wireAbaCode$ | async) !== abaCodes.ABA_ERROR && !aba.invalid && !(wireInfo$ | async)?.loading) || useSloa || useTemplateShowFields"
      class="bank-details" data-testid="receiving-bank-details-section">
      <div *ngIf="!showIsoReceivingBankDetails">
        <span id="bank-details-header">{{abaInfoLabel}}</span>
        <span class="bank-details-line">{{receivingBankName1.value}}</span>
        <span class="bank-details-line">{{receivingBankName2.value}}</span>
        <span class="bank-details-line">{{receivingBankAddress1.value}}</span>
        <span class="bank-details-line">{{receivingBankAddress2.value}}</span>
        <span class="bank-details-line">{{receivingBankCountry.value}}</span>
        <span class="bank-details-line">{{receivingBankPhoneNumber.value}}</span>
      </div>
      <div *ngIf="showIsoReceivingBankDetails">
        <span id="bank-details-header">{{abaInfoLabel}}</span>
        <span *ngIf="receivingBankName != null" class="bank-details-line">{{receivingBankName.value}}</span>
        <span *ngIf="receivingBankCity != null && receivingBankState != null" class="bank-details-line">{{receivingBankCity.value}} {{receivingBankState.value}} </span>
        <span *ngIf="country != null" class="bank-details-line">{{country.value}}</span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="useSloa">
  <div id="resp-table">
    <div id="resp-table-body">
      <div class="resp-table-row">
        <span id="bank-id-label" for="aba" [class.error-text]="aba.touched && aba.invalid" data-testid="aba-label"
          [ngClass]="isISOCompliant ? 'table-body-cell schwab-grey' : 'gap'">{{abaLabel}}</span>
        <span *ngIf="isoCompliantWithSecondIdentifier" id="second-identifier-label" data-testid="second-identifier-label" [ngClass]="isISOCompliant ? 'table-body-cell schwab-grey' : 'gap'">Clearing system ID</span>
        <span class="table-body-cell schwab-grey bank-details-header" *ngIf="((wireInfo$ | async)?.detailsCallSucceeded && (wireAbaCode$ | async) !== abaCodes.ABA_ERROR && !aba.invalid && !(wireInfo$ | async)?.loading) || useSloa || useTemplateShowFields"
          data-testid="receiving-bank-details-section">
          {{abaInfoLabel}}
        </span>
      </div>
    </div>
  </div>
  <div id="resp-table">
    <div id="resp-table-body">
      <div class="resp-table-row">
        <span *ngIf="isISOCompliant" class="table-body-cell" id="aba-sloa" data-testid="aba-input-sloa">{{aba.value}}</span>
        <span *ngIf="!isISOCompliant" class="gap">
          <input [readonly]="useSloa" type="text" class="sdps-input sdps-input--small" id="aba-sloa-compliant"
          data-testid="aba-input-sloa-compliant" [value]="aba.value">
        </span>
        <span *ngIf="isoCompliantWithSecondIdentifier" class="table-body-cell" id="second-identifier" data-testid="second-identifier">{{clearingSystemId}}</span>
        <span class="table-body-cell">
          <span [ngClass]="isISOCompliant ? 'no-margin bank-details-line' : 'bottom-margin'" style="white-space: pre-line;">{{useSloaAddress}}</span>
        </span>
      </div>
    </div>
  </div>
</div>
